// source: https://www.w3schools.com/css/css_tooltip.asp

import React from "react";
import classNames from "classnames";

import styles from "./SimpleToolTip.module.scss";

interface Props {
    content: React.ReactNode;
    children: React.ReactElement<any>;
    className?: string;
    centered?: boolean;
    contentStyle?: string;
    visible?: boolean;
}

const SimpleToolTip = ({
    content,
    children,
    className,
    centered,
    contentStyle,
    visible = true,
}: Props) => {
    return (
        <>
            {visible ? (
                <div className={classNames(styles["simple-tooltip"], className)}>
                    {children}
                    <div
                        className={classNames(
                            styles["simple-tooltip__content"],
                            contentStyle,
                            centered && styles["centered"],
                            !centered && styles["left"],
                        )}
                    >
                        {content}
                    </div>
                </div>
            ) : null}
        </>
    );
};

export default SimpleToolTip;
